<div class="medical-record-form-wrapper">
  <!-- form -->
  <form [formGroup]="form" class="medical-record-form" *ngIf="form">
    <!-- title -->
    <app-form-input-text [field]="'title'" [formControl]="f['title']" formControlName="title"></app-form-input-text>
    <!-- patient -->
    <app-form-input-text [field]="'patient'" [formControl]="f['patient']" formControlName="patient"></app-form-input-text>
    <!-- start date -->
    <app-form-input-date [field]="'startDate'" [formControl]="f['startDate']" formControlName="startDate"
      [maxDate]="f['id']?.value ? undefined : today"></app-form-input-date>
    <!-- anamnesis -->
    <app-form-input-editor [field]="'anamnesis'" [formControl]="f['anamnesis']"
      [formControlName]="'anamnesis'" [height]="'15vh'"></app-form-input-editor>
    <!-- diagnosis -->
    <app-form-input-editor [field]="'diagnosis'" [formControl]="f['diagnosis']"
      [formControlName]="'diagnosis'" [height]="'15vh'"></app-form-input-editor>
    <!-- therapy -->
    <app-form-input-editor [field]="'therapy'" [formControl]="f['therapy']"
      [formControlName]="'therapy'" [height]="'15vh'"></app-form-input-editor>
  </form>
  <!-- buttons -->
  <div class="buttons">
    <p-button [label]="'button.cancel' | translate" severity="secondary" (click)="cancel()"/>
    <p-button [label]="'button.save' | translate" severity="contrast" (click)="save()"/>
  </div>
</div>
    